<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader></cnHeader>
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/faq">FAQ</a>
				</div>
				<cnPubtips></cnPubtips>
			</div>
			<!--面包屑与公共提醒-结束-->
			<!--页面内容-开始-->
			<div class="faq_content">
				<div class="title">FAQ</div>
				<div class="faq_list_box">					
					
					<!--无数据-->
					<cnNoData :isShow="noDataIsShow"></cnNoData>
					
					<div class="item" v-for="(item, index) in faqList" :key="index">
						<a :href="'/cn/faq/detail?Id='+item.Id" target="_blank">
						<h3>{{item.Title}}</h3>
						<p>{{item.SubTitle}}</p>
						</a>
					</div>
					
					<!--分页-开始-->
					<div class="page_ctrl" v-if="faqList.length>0 && pageTotal>1">
						<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
							:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
						</el-pagination>
					</div>
					<!--分页-结束-->
					
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		checkToken,
		getFaqList,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnPubtips from '@/components/cn_pubtips.vue'
	import cnFooter from '@/components/cn_footer.vue'
	import cnNoData from '@/components/cn_noData.vue'
	export default {
		name: 'CN_FaqPage',
		mixins: [mixin],
		components: {
			cnHeader,
			cnPubtips,
			cnFooter,
			cnNoData,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				noDataIsShow: false, //无数据缺省
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				errMessage: '非正常加载页面',
				
				pageIndex: 1, 		//页码，默认为1
				pageSize: 10, 		//每页显示条数
				pageTotal: 0, 		//总页数
				recordTotal: 0, 	//总条数
				faqList: [],		//数据列表
			}
		},
		created() {
			this.getData()
		},
		methods: {
			//获取数据
			async getData() {
				const { data: res } = await getFaqList(this.language, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.faqList = res.data.FaqList
					this.pageTotal = res.data.PageTotal
					this.recordTotal = res.data.RecordTotal					
					if(this.faqList.length >0)
					{
						this.noDataIsShow = false
						this.$nextTick(() => {
							window.scrollTo(0, 0);
						});
					} else {
						this.noDataIsShow = true
					}
					
				} else {
					this.errMessage = res.errmsg
				}
			},
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		
		.faq_list_box {
			margin-top: 30px;
			
			.item {
				background: #FAFBFF;
				border-radius: 8px;
				padding: 20px;
				margin-top: 15px;
				
				a {
					color: #111;
				}
				a:hover {
					color: #008768;
				}
			
				h3 {
					font-size: 15px;
					font-weight: 400;
					background-image: url(@/assets/images/icons/question.png);
					background-size: 16px 16px;
					background-repeat: no-repeat;
					background-position: left 2px;
					padding-left: 24px;
				}
			
				p {
					margin-top: 6px;
					font-size: 13px;
					background-image: url(@/assets/images/icons/answer.png);
					background-size: 16px 16px;
					background-repeat: no-repeat;
					background-position: left 2px;
					padding-left: 24px;
				}
			}
		}
		
		
		
		/deep/ .el-pagination {
			font-size: 14px;
		}
		
		/deep/ .el-pager li {
			margin: 0 5px;
			border-radius: 5px;
		}
		
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #008768;
		}
	}
</style>